import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useMutation } from 'react-query'
import { AlmanacFile, MediaTransformations } from 'types'

type MediaFileAttributes = {
  source_url: string
  mime_type: string
  title: string
  project_key: string
  show_in_file_system?: boolean
  variants?: Array<MediaTransformations>
}

type Data = AlmanacFile

type Variables = MediaFileAttributes

export const createMediaFile = async (workspaceId: number, variables: MediaFileAttributes) => {
  const res = await sendToApi(`/w/${workspaceId}/media_files`, {
    method: 'POST',
    body: variables,
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data.almanac_file
}

export const useCreateMediaFile = () => {
  const workspaceId = useCurrentWorkspaceId()
  return useMutation<Data, Error, Variables>((vars) => createMediaFile(workspaceId, vars))
}
